// Angular Files
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule } from '@angular/router';

// Component
import { PublicPortalHeaderComponent } from './public-portal-header.component';

// Directives
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
    declarations: [
        PublicPortalHeaderComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        MatBadgeModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        MatDividerModule,
        DirectivesModule
    ],
    exports: [
        PublicPortalHeaderComponent
    ]
})
export class PublicPortalHeaderModule { }
